import './PluginCustomComponent.less';

export default function PluginCustomComponent(props) {
  /**
   * 返回组件（TODO：如果非预览，应该要隐藏当前组件）
   */
  return (
    <div className="custom-component plugin">
      <p>插件组件（仅支持微信小程序）</p>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/plugin-custom-component/PluginCustomComponent.jsx